import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CollapseAll } from '../../../webcommon/common/Icons/Collape All.svg';
import { ReactComponent as ExpandAll } from '../../../webcommon/common/Icons/Expand All.svg';
import { noop } from 'lodash';
import styles from '../GridHeaderButton.module.scss';

const ExpanderButton = props => (
    <button
        className={ styles.gridHeaderButton }
        type="button"
        onClick={ props.setAllExpanded }
    >
        {props.allExpanded ? (<div>Collapse All <CollapseAll /></div>)
            : (<div>Expand All <ExpandAll /></div>) }
    </button>
);

ExpanderButton.propTypes = {
    allExpanded: PropTypes.bool,
    setAllExpanded: PropTypes.func
};

ExpanderButton.defaultProps = {
    allExpanded: true,
    setAllExpanded: noop
};

export default ExpanderButton;
